export default "__VITE_ASSET__2ctLaO69__"